/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  SelectField,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { View } from "@aws-amplify/ui-react";
import { StorageManager } from "@aws-amplify/ui-react-storage";
import { Product } from "../models";
import {
  fetchByPath,
  getOverrideProps,
  processFile,
  validateField,
} from "./ProductCreateUtils";
import { Field } from "@aws-amplify/ui-react/internal";
import { DataStore } from "aws-amplify";
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function ProductCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const { tokens } = useTheme();
  const initialValues = {
    brand_name: "",
    product_name: "",
    registered_region: "",
    style: "",
    price_ex_vat: "",
    bottles_per_year: "",
    year_of_production: "",
    container_size_cl: "",
    abv_percentage: "",
    tags: [],
    product_image: undefined,
    techSheetDescription: "",
    techSheetProductType: "",
    techSheetSoil: "",
    techSheetProductionArea: "",
    techSheetFormat: "",
    techSheetAgingCapacity: "",
    techSheetYearOfPlanting: "",
    techSheetVinification: "",
    techSheetAppearance: "",
    techSheetNose: "",
    techSheetPalate: "",
    techSheetPairings: [],
    techSheetServingTemperatureMin: "",
    techSheetServingTemperatureMax: "",
    techSheetCertifications: [],
  };
  const [brand_name, setBrand_name] = React.useState(initialValues.brand_name);
  const [product_name, setProduct_name] = React.useState(
    initialValues.product_name
  );
  const [registered_region, setRegistered_region] = React.useState(
    initialValues.registered_region
  );
  const [style, setStyle] = React.useState(initialValues.style);
  const [price_ex_vat, setPrice_ex_vat] = React.useState(
    initialValues.price_ex_vat
  );
  const [bottles_per_year, setBottles_per_year] = React.useState(
    initialValues.bottles_per_year
  );
  const [year_of_production, setYear_of_production] = React.useState(
    initialValues.year_of_production
  );
  const [container_size_cl, setContainer_size_cl] = React.useState(
    initialValues.container_size_cl
  );
  const [abv_percentage, setAbv_percentage] = React.useState(
    initialValues.abv_percentage
  );
  const [tags, setTags] = React.useState(initialValues.tags);
  const [product_image, setProduct_image] = React.useState(
    initialValues.product_image
  );
  const [techSheetDescription, setTechSheetDescription] = React.useState(
    initialValues.techSheetDescription
  );
  const [techSheetProductType, setTechSheetProductType] = React.useState(
    initialValues.techSheetProductType
  );
  const [techSheetSoil, setTechSheetSoil] = React.useState(
    initialValues.techSheetSoil
  );
  const [techSheetProductionArea, setTechSheetProductionArea] = React.useState(
    initialValues.techSheetProductionArea
  );
  const [techSheetFormat, setTechSheetFormat] = React.useState(
    initialValues.techSheetFormat
  );
  const [techSheetAgingCapacity, setTechSheetAgingCapacity] = React.useState(
    initialValues.techSheetAgingCapacity
  );
  const [techSheetYearOfPlanting, setTechSheetYearOfPlanting] = React.useState(
    initialValues.techSheetYearOfPlanting
  );
  const [techSheetVinification, setTechSheetVinification] = React.useState(
    initialValues.techSheetVinification
  );
  const [techSheetAppearance, setTechSheetAppearance] = React.useState(
    initialValues.techSheetAppearance
  );
  const [techSheetNose, setTechSheetNose] = React.useState(
    initialValues.techSheetNose
  );
  const [techSheetPalate, setTechSheetPalate] = React.useState(
    initialValues.techSheetPalate
  );
  const [techSheetPairings, setTechSheetPairings] = React.useState(
    initialValues.techSheetPairings
  );
  const [techSheetServingTemperatureMin, setTechSheetServingTemperatureMin] =
    React.useState(initialValues.techSheetServingTemperatureMin);
  const [techSheetServingTemperatureMax, setTechSheetServingTemperatureMax] =
    React.useState(initialValues.techSheetServingTemperatureMax);
  const [techSheetCertifications, setTechSheetCertifications] = React.useState(
    initialValues.techSheetCertifications
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setBrand_name(initialValues.brand_name);
    setProduct_name(initialValues.product_name);
    setRegistered_region(initialValues.registered_region);
    setStyle(initialValues.style);
    setPrice_ex_vat(initialValues.price_ex_vat);
    setBottles_per_year(initialValues.bottles_per_year);
    setYear_of_production(initialValues.year_of_production);
    setContainer_size_cl(initialValues.container_size_cl);
    setAbv_percentage(initialValues.abv_percentage);
    setTags(initialValues.tags);
    setCurrentTagsValue("");
    setProduct_image(initialValues.product_image);
    setTechSheetDescription(initialValues.techSheetDescription);
    setTechSheetProductType(initialValues.techSheetProductType);
    setTechSheetSoil(initialValues.techSheetSoil);
    setTechSheetProductionArea(initialValues.techSheetProductionArea);
    setTechSheetFormat(initialValues.techSheetFormat);
    setTechSheetAgingCapacity(initialValues.techSheetAgingCapacity);
    setTechSheetYearOfPlanting(initialValues.techSheetYearOfPlanting);
    setTechSheetVinification(initialValues.techSheetVinification);
    setTechSheetAppearance(initialValues.techSheetAppearance);
    setTechSheetNose(initialValues.techSheetNose);
    setTechSheetPalate(initialValues.techSheetPalate);
    setTechSheetPairings(initialValues.techSheetPairings);
    setCurrentTechSheetPairingsValue("");
    setTechSheetServingTemperatureMin(
      initialValues.techSheetServingTemperatureMin
    );
    setTechSheetServingTemperatureMax(
      initialValues.techSheetServingTemperatureMax
    );
    setTechSheetCertifications(initialValues.techSheetCertifications);
    setCurrentTechSheetCertificationsValue("");
    setErrors({});
  };
  const [currentTagsValue, setCurrentTagsValue] = React.useState("");
  const tagsRef = React.createRef();
  const [currentTechSheetPairingsValue, setCurrentTechSheetPairingsValue] =
    React.useState("");
  const techSheetPairingsRef = React.createRef();
  const [
    currentTechSheetCertificationsValue,
    setCurrentTechSheetCertificationsValue,
  ] = React.useState("");
  const techSheetCertificationsRef = React.createRef();
  const validations = {
    brand_name: [{ type: "Required" }],
    product_name: [{ type: "Required" }],
    registered_region: [{ type: "Required" }],
    style: [{ type: "Required" }],
    price_ex_vat: [{ type: "Required" }],
    bottles_per_year: [{ type: "Required" }],
    year_of_production: [{ type: "Required" }],
    container_size_cl: [{ type: "Required" }],
    abv_percentage: [{ type: "Required" }],
    tags: [{ type: "Required" }],
    product_image: [{ type: "Required" }],
    techSheetDescription: [],
    techSheetProductType: [],
    techSheetSoil: [],
    techSheetProductionArea: [],
    techSheetFormat: [],
    techSheetAgingCapacity: [],
    techSheetYearOfPlanting: [],
    techSheetVinification: [],
    techSheetAppearance: [],
    techSheetNose: [],
    techSheetPalate: [],
    techSheetPairings: [],
    techSheetServingTemperatureMin: [],
    techSheetServingTemperatureMax: [],
    techSheetCertifications: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap={tokens.space.large.value}
      columnGap={tokens.space.large.value}
      padding={tokens.space.large.value}
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          brand_name,
          product_name,
          registered_region,
          style,
          price_ex_vat,
          bottles_per_year,
          year_of_production,
          container_size_cl,
          abv_percentage,
          tags,
          product_image,
          techSheetDescription,
          techSheetProductType,
          techSheetSoil,
          techSheetProductionArea,
          techSheetFormat,
          techSheetAgingCapacity,
          techSheetYearOfPlanting,
          techSheetVinification,
          techSheetAppearance,
          techSheetNose,
          techSheetPalate,
          techSheetPairings,
          techSheetServingTemperatureMin,
          techSheetServingTemperatureMax,
          techSheetCertifications,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new Product(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "ProductCreateForm")}
      {...rest}
    >
      <TextField
        label={
          <span>
            Nome del brand<span style={{ color: "red" }}> *</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        value={brand_name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name: value,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.brand_name ?? value;
          }
          if (errors.brand_name?.hasError) {
            runValidationTasks("brand_name", value);
          }
          setBrand_name(value);
        }}
        onBlur={() => runValidationTasks("brand_name", brand_name)}
        errorMessage={errors.brand_name?.errorMessage}
        hasError={errors.brand_name?.hasError}
        {...getOverrideProps(overrides, "brand_name")}
      ></TextField>
      <TextField
        label={
          <span>
            Nome del prodotto<span style={{ color: "red" }}> *</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        value={product_name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name: value,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.product_name ?? value;
          }
          if (errors.product_name?.hasError) {
            runValidationTasks("product_name", value);
          }
          setProduct_name(value);
        }}
        onBlur={() => runValidationTasks("product_name", product_name)}
        errorMessage={errors.product_name?.errorMessage}
        hasError={errors.product_name?.hasError}
        {...getOverrideProps(overrides, "product_name")}
      ></TextField>
      <SelectField
        label={
          <span>
            Regione di produzione<span style={{ color: "red" }}> *</span>
          </span>
        }
        placeholder="Seleziona una regione"
        isDisabled={false}
        value={registered_region}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region: value,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.registered_region ?? value;
          }
          if (errors.registered_region?.hasError) {
            runValidationTasks("registered_region", value);
          }
          setRegistered_region(value);
        }}
        onBlur={() =>
          runValidationTasks("registered_region", registered_region)
        }
        errorMessage={errors.registered_region?.errorMessage}
        hasError={errors.registered_region?.hasError}
        {...getOverrideProps(overrides, "registered_region")}
      >
        <option
          children="Abruzzo"
          value="Abruzzo"
          {...getOverrideProps(overrides, "registered_regionoption0")}
        ></option>
        <option
          children="Basilicata"
          value="Basilicata"
          {...getOverrideProps(overrides, "registered_regionoption1")}
        ></option>
        <option
          children="Calabria"
          value="Calabria"
          {...getOverrideProps(overrides, "registered_regionoption2")}
        ></option>
        <option
          children="Campania"
          value="Campania"
          {...getOverrideProps(overrides, "registered_regionoption3")}
        ></option>
        <option
          children="Emilia-Romagna"
          value="Emilia-Romagna"
          {...getOverrideProps(overrides, "registered_regionoption4")}
        ></option>
        <option
          children="Friuli Venezia Giulia"
          value="Friuli Venezia Giulia"
          {...getOverrideProps(overrides, "registered_regionoption5")}
        ></option>
        <option
          children="Lazio"
          value="Lazio"
          {...getOverrideProps(overrides, "registered_regionoption6")}
        ></option>
        <option
          children="Liguria"
          value="Liguria"
          {...getOverrideProps(overrides, "registered_regionoption7")}
        ></option>
        <option
          children="Lombardia"
          value="Lombardia"
          {...getOverrideProps(overrides, "registered_regionoption8")}
        ></option>
        <option
          children="Marche"
          value="Marche"
          {...getOverrideProps(overrides, "registered_regionoption9")}
        ></option>
        <option
          children="Molise"
          value="Molise"
          {...getOverrideProps(overrides, "registered_regionoption10")}
        ></option>
        <option
          children="Piemonte"
          value="Piemonte"
          {...getOverrideProps(overrides, "registered_regionoption11")}
        ></option>
        <option
          children="Puglia"
          value="Puglia"
          {...getOverrideProps(overrides, "registered_regionoption12")}
        ></option>
        <option
          children="Sardegna"
          value="Sardegna"
          {...getOverrideProps(overrides, "registered_regionoption13")}
        ></option>
        <option
          children="Sicilia"
          value="Sicilia"
          {...getOverrideProps(overrides, "registered_regionoption14")}
        ></option>
        <option
          children="Toscana"
          value="Toscana"
          {...getOverrideProps(overrides, "registered_regionoption15")}
        ></option>
        <option
          children="Trentino-Alto Adige"
          value="Trentino-Alto Adige"
          {...getOverrideProps(overrides, "registered_regionoption16")}
        ></option>
        <option
          children="Umbria"
          value="Umbria"
          {...getOverrideProps(overrides, "registered_regionoption17")}
        ></option>
        <option
          children="Valle d'Aosta"
          value="Valle d'Aosta"
          {...getOverrideProps(overrides, "registered_regionoption18")}
        ></option>
        <option
          children="Veneto"
          value="Veneto"
          {...getOverrideProps(overrides, "registered_regionoption19")}
        ></option>
      </SelectField>
      <SelectField
        label={
          <span>
            Categoria<span style={{ color: "red" }}> *</span>
          </span>
        }
        placeholder="Seleziona una categoria"
        isDisabled={false}
        value={style}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style: value,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.style ?? value;
          }
          if (errors.style?.hasError) {
            runValidationTasks("style", value);
          }
          setStyle(value);
        }}
        onBlur={() => runValidationTasks("style", style)}
        errorMessage={errors.style?.errorMessage}
        hasError={errors.style?.hasError}
        {...getOverrideProps(overrides, "style")}
      >
        <option
          children="White Wine"
          value="White Wine"
          {...getOverrideProps(overrides, "styleoption0")}
        ></option>
        <option
          children="Red Wine"
          value="Red Wine"
          {...getOverrideProps(overrides, "styleoption1")}
        ></option>
        <option
          children="Rosé Wine"
          value="Rosé Wine"
          {...getOverrideProps(overrides, "styleoption2")}
        ></option>
        <option
          children="Sparkling Wine"
          value="Sparkling Wine"
          {...getOverrideProps(overrides, "styleoption3")}
        ></option>
        <option
          children="Liqueur"
          value="Liqueur"
          {...getOverrideProps(overrides, "styleoption4")}
        ></option>
        <option
          children="Spirits"
          value="Spirits"
          {...getOverrideProps(overrides, "styleoption5")}
        ></option>
        <option
          children="Ready-to-Drink"
          value="Ready-to-Drink"
          {...getOverrideProps(overrides, "styleoption6")}
        ></option>
        <option
          children="Other"
          value="Other"
          {...getOverrideProps(overrides, "styleoption7")}
        ></option>
      </SelectField>
      <TextField
        label={
          <span>
            Prezzo export esclusa iva (EUR)<span style={{ color: "red" }}> *</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        type="number"
        step="any"
        value={price_ex_vat}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat: value,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.price_ex_vat ?? value;
          }
          if (errors.price_ex_vat?.hasError) {
            runValidationTasks("price_ex_vat", value);
          }
          setPrice_ex_vat(value);
        }}
        onBlur={() => runValidationTasks("price_ex_vat", price_ex_vat)}
        errorMessage={errors.price_ex_vat?.errorMessage}
        hasError={errors.price_ex_vat?.hasError}
        {...getOverrideProps(overrides, "price_ex_vat")}
      ></TextField>
      <TextField
        label={
          <span>
            Bottiglie prodotte all'anno<span style={{ color: "red" }}> *</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        type="number"
        step="any"
        value={bottles_per_year}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year: value,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.bottles_per_year ?? value;
          }
          if (errors.bottles_per_year?.hasError) {
            runValidationTasks("bottles_per_year", value);
          }
          setBottles_per_year(value);
        }}
        onBlur={() => runValidationTasks("bottles_per_year", bottles_per_year)}
        errorMessage={errors.bottles_per_year?.errorMessage}
        hasError={errors.bottles_per_year?.hasError}
        {...getOverrideProps(overrides, "bottles_per_year")}
      ></TextField>
      <TextField
        label={
          <span>
            Anno di produzione<span style={{ color: "red" }}> *</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        type="number"
        step="any"
        value={year_of_production}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production: value,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.year_of_production ?? value;
          }
          if (errors.year_of_production?.hasError) {
            runValidationTasks("year_of_production", value);
          }
          setYear_of_production(value);
        }}
        onBlur={() =>
          runValidationTasks("year_of_production", year_of_production)
        }
        errorMessage={errors.year_of_production?.errorMessage}
        hasError={errors.year_of_production?.hasError}
        {...getOverrideProps(overrides, "year_of_production")}
      ></TextField>
      <TextField
        label={
          <span>
            Volume bottiglia (cl)<span style={{ color: "red" }}> *</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        type="number"
        step="any"
        value={container_size_cl}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl: value,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.container_size_cl ?? value;
          }
          if (errors.container_size_cl?.hasError) {
            runValidationTasks("container_size_cl", value);
          }
          setContainer_size_cl(value);
        }}
        onBlur={() =>
          runValidationTasks("container_size_cl", container_size_cl)
        }
        errorMessage={errors.container_size_cl?.errorMessage}
        hasError={errors.container_size_cl?.hasError}
        {...getOverrideProps(overrides, "container_size_cl")}
      ></TextField>
      <TextField
        label={
          <span>
            ABV %<span style={{ color: "red" }}> *</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        type="number"
        step="any"
        value={abv_percentage}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage: value,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.abv_percentage ?? value;
          }
          if (errors.abv_percentage?.hasError) {
            runValidationTasks("abv_percentage", value);
          }
          setAbv_percentage(value);
        }}
        onBlur={() => runValidationTasks("abv_percentage", abv_percentage)}
        errorMessage={errors.abv_percentage?.errorMessage}
        hasError={errors.abv_percentage?.hasError}
        {...getOverrideProps(overrides, "abv_percentage")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags: values,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            values = result?.tags ?? values;
          }
          setTags(values);
          setCurrentTagsValue("");
        }}
        currentFieldValue={currentTagsValue}
        label={
          <span>
            Tags<span style={{ color: "red" }}> *</span>
          </span>
        }
        items={tags}
        hasError={errors?.tags?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("tags", currentTagsValue)
        }
        errorMessage={errors?.tags?.errorMessage}
        setFieldValue={setCurrentTagsValue}
        inputFieldRef={tagsRef}
        defaultFieldValue={""}
      >
        <SelectField
          label="Tags"
          descriptiveText="Tra questi tag scegli quello che meglio rappresenta il tuo prodotto!"
          placeholder="Seleziona un tag"
          isDisabled={false}
          value={currentTagsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.tags?.hasError) {
              runValidationTasks("tags", value);
            }
            setCurrentTagsValue(value);
          }}
          onBlur={() => runValidationTasks("tags", currentTagsValue)}
          errorMessage={errors.tags?.errorMessage}
          hasError={errors.tags?.hasError}
          ref={tagsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "tags")}
        >
          <option
            children="Biologico"
            value="Biologico"
            {...getOverrideProps(overrides, "tagsoption0")}
          ></option>
          <option
            children="Biodinamico"
            value="Biodinamico"
            {...getOverrideProps(overrides, "tagsoption1")}
          ></option>
          <option
            children="Naturale"
            value="Naturale"
            {...getOverrideProps(overrides, "tagsoption2")}
          ></option>
          <option
            children="DOCG"
            value="DOCG"
            {...getOverrideProps(overrides, "tagsoption3")}
          ></option>
          <option
            children="DOC"
            value="DOC"
            {...getOverrideProps(overrides, "tagsoption4")}
          ></option>
          <option
            children="IGT"
            value="IGT"
            {...getOverrideProps(overrides, "tagsoption5")}
          ></option>
          <option
            children="IGP"
            value="IGP"
            {...getOverrideProps(overrides, "tagsoption6")}
          ></option>
          <option
            children="DOP"
            value="DOP"
            {...getOverrideProps(overrides, "tagsoption7")}
          ></option>
          <option
            children="Vegano"
            value="Vegano"
            {...getOverrideProps(overrides, "tagsoption8")}
          ></option>
          <option
            children="Nessuno"
            value="Nessuno"
            {...getOverrideProps(overrides, "tagsoption9")}
          ></option>
        </SelectField>
      </ArrayField>
      <Field
        errorMessage={errors.product_image?.errorMessage}
        hasError={errors.product_image?.hasError}
        label={
          <span>
            Foto del prodotto<span style={{ color: "red" }}> *</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
      >
        <StorageManager
          onUploadSuccess={({ key }) => {
            setProduct_image((prev) => {
              let value = key;
              if (onChange) {
                const modelFields = {
                  brand_name,
                  product_name,
                  registered_region,
                  style,
                  price_ex_vat,
                  bottles_per_year,
                  year_of_production,
                  container_size_cl,
                  abv_percentage,
                  tags,
                  product_image: value,
                  techSheetDescription,
                  techSheetProductType,
                  techSheetSoil,
                  techSheetProductionArea,
                  techSheetFormat,
                  techSheetAgingCapacity,
                  techSheetYearOfPlanting,
                  techSheetVinification,
                  techSheetAppearance,
                  techSheetNose,
                  techSheetPalate,
                  techSheetPairings,
                  techSheetServingTemperatureMin,
                  techSheetServingTemperatureMax,
                  techSheetCertifications,
                };
                const result = onChange(modelFields);
                value = result?.product_image ?? value;
              }
              return value;
            });
          }}
          onFileRemove={({ key }) => {
            setProduct_image((prev) => {
              let value = initialValues?.product_image;
              if (onChange) {
                const modelFields = {
                  brand_name,
                  product_name,
                  registered_region,
                  style,
                  price_ex_vat,
                  bottles_per_year,
                  year_of_production,
                  container_size_cl,
                  abv_percentage,
                  tags,
                  product_image: value,
                  techSheetDescription,
                  techSheetProductType,
                  techSheetSoil,
                  techSheetProductionArea,
                  techSheetFormat,
                  techSheetAgingCapacity,
                  techSheetYearOfPlanting,
                  techSheetVinification,
                  techSheetAppearance,
                  techSheetNose,
                  techSheetPalate,
                  techSheetPairings,
                  techSheetServingTemperatureMin,
                  techSheetServingTemperatureMax,
                  techSheetCertifications,
                };
                const result = onChange(modelFields);
                value = result?.product_image ?? value;
              }
              return value;
            });
          }}
          processFile={processFile}
          accessLevel={"public"}
          acceptedFileTypes={[]}
          isResumable={false}
          showThumbnails={true}
          maxFileCount={1}
          maxSize={25000000}
          {...getOverrideProps(overrides, "product_image")}
        ></StorageManager>
      </Field>

      <br></br>
      <h2>
        Scheda Tecnica (opzionale)
      </h2>
      <TextField
        label="Descrizione"
        isRequired={false}
        isReadOnly={false}
        value={techSheetDescription}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription: value,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetDescription ?? value;
          }
          if (errors.techSheetDescription?.hasError) {
            runValidationTasks("techSheetDescription", value);
          }
          setTechSheetDescription(value);
        }}
        onBlur={() =>
          runValidationTasks("techSheetDescription", techSheetDescription)
        }
        errorMessage={errors.techSheetDescription?.errorMessage}
        hasError={errors.techSheetDescription?.hasError}
        {...getOverrideProps(overrides, "techSheetDescription")}
      ></TextField>
      <TextField
        label="Tipo di prodotto"
        isRequired={false}
        isReadOnly={false}
        value={techSheetProductType}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType: value,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetProductType ?? value;
          }
          if (errors.techSheetProductType?.hasError) {
            runValidationTasks("techSheetProductType", value);
          }
          setTechSheetProductType(value);
        }}
        onBlur={() =>
          runValidationTasks("techSheetProductType", techSheetProductType)
        }
        errorMessage={errors.techSheetProductType?.errorMessage}
        hasError={errors.techSheetProductType?.hasError}
        {...getOverrideProps(overrides, "techSheetProductType")}
      ></TextField>
      <TextField
        label="Tipo di Terreno"
        isRequired={false}
        isReadOnly={false}
        value={techSheetSoil}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil: value,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetSoil ?? value;
          }
          if (errors.techSheetSoil?.hasError) {
            runValidationTasks("techSheetSoil", value);
          }
          setTechSheetSoil(value);
        }}
        onBlur={() => runValidationTasks("techSheetSoil", techSheetSoil)}
        errorMessage={errors.techSheetSoil?.errorMessage}
        hasError={errors.techSheetSoil?.hasError}
        {...getOverrideProps(overrides, "techSheetSoil")}
      ></TextField>
      <TextField
        label="Area di produzione"
        isRequired={false}
        isReadOnly={false}
        value={techSheetProductionArea}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea: value,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetProductionArea ?? value;
          }
          if (errors.techSheetProductionArea?.hasError) {
            runValidationTasks("techSheetProductionArea", value);
          }
          setTechSheetProductionArea(value);
        }}
        onBlur={() =>
          runValidationTasks("techSheetProductionArea", techSheetProductionArea)
        }
        errorMessage={errors.techSheetProductionArea?.errorMessage}
        hasError={errors.techSheetProductionArea?.hasError}
        {...getOverrideProps(overrides, "techSheetProductionArea")}
      ></TextField>
      <TextField
        label="Altri formati disponibili"
        isRequired={false}
        isReadOnly={false}
        value={techSheetFormat}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat: value,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetFormat ?? value;
          }
          if (errors.techSheetFormat?.hasError) {
            runValidationTasks("techSheetFormat", value);
          }
          setTechSheetFormat(value);
        }}
        onBlur={() => runValidationTasks("techSheetFormat", techSheetFormat)}
        errorMessage={errors.techSheetFormat?.errorMessage}
        hasError={errors.techSheetFormat?.hasError}
        {...getOverrideProps(overrides, "techSheetFormat")}
      ></TextField>
      <TextField
        label="Invecchiamento"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={techSheetAgingCapacity}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity: value,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetAgingCapacity ?? value;
          }
          if (errors.techSheetAgingCapacity?.hasError) {
            runValidationTasks("techSheetAgingCapacity", value);
          }
          setTechSheetAgingCapacity(value);
        }}
        onBlur={() =>
          runValidationTasks("techSheetAgingCapacity", techSheetAgingCapacity)
        }
        errorMessage={errors.techSheetAgingCapacity?.errorMessage}
        hasError={errors.techSheetAgingCapacity?.hasError}
        {...getOverrideProps(overrides, "techSheetAgingCapacity")}
      ></TextField>
      <TextField
        label="Anno di impianto"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={techSheetYearOfPlanting}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting: value,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetYearOfPlanting ?? value;
          }
          if (errors.techSheetYearOfPlanting?.hasError) {
            runValidationTasks("techSheetYearOfPlanting", value);
          }
          setTechSheetYearOfPlanting(value);
        }}
        onBlur={() =>
          runValidationTasks("techSheetYearOfPlanting", techSheetYearOfPlanting)
        }
        errorMessage={errors.techSheetYearOfPlanting?.errorMessage}
        hasError={errors.techSheetYearOfPlanting?.hasError}
        {...getOverrideProps(overrides, "techSheetYearOfPlanting")}
      ></TextField>
      <TextField
        label="Vinificazione"
        isRequired={false}
        isReadOnly={false}
        value={techSheetVinification}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification: value,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetVinification ?? value;
          }
          if (errors.techSheetVinification?.hasError) {
            runValidationTasks("techSheetVinification", value);
          }
          setTechSheetVinification(value);
        }}
        onBlur={() =>
          runValidationTasks("techSheetVinification", techSheetVinification)
        }
        errorMessage={errors.techSheetVinification?.errorMessage}
        hasError={errors.techSheetVinification?.hasError}
        {...getOverrideProps(overrides, "techSheetVinification")}
      ></TextField>
      <TextField
        label="Aspetto"
        isRequired={false}
        isReadOnly={false}
        value={techSheetAppearance}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance: value,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetAppearance ?? value;
          }
          if (errors.techSheetAppearance?.hasError) {
            runValidationTasks("techSheetAppearance", value);
          }
          setTechSheetAppearance(value);
        }}
        onBlur={() =>
          runValidationTasks("techSheetAppearance", techSheetAppearance)
        }
        errorMessage={errors.techSheetAppearance?.errorMessage}
        hasError={errors.techSheetAppearance?.hasError}
        {...getOverrideProps(overrides, "techSheetAppearance")}
      ></TextField>
      <TextField
        label="Naso"
        isRequired={false}
        isReadOnly={false}
        value={techSheetNose}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose: value,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetNose ?? value;
          }
          if (errors.techSheetNose?.hasError) {
            runValidationTasks("techSheetNose", value);
          }
          setTechSheetNose(value);
        }}
        onBlur={() => runValidationTasks("techSheetNose", techSheetNose)}
        errorMessage={errors.techSheetNose?.errorMessage}
        hasError={errors.techSheetNose?.hasError}
        {...getOverrideProps(overrides, "techSheetNose")}
      ></TextField>
      <TextField
        label="Palato"
        isRequired={false}
        isReadOnly={false}
        value={techSheetPalate}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate: value,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetPalate ?? value;
          }
          if (errors.techSheetPalate?.hasError) {
            runValidationTasks("techSheetPalate", value);
          }
          setTechSheetPalate(value);
        }}
        onBlur={() => runValidationTasks("techSheetPalate", techSheetPalate)}
        errorMessage={errors.techSheetPalate?.errorMessage}
        hasError={errors.techSheetPalate?.hasError}
        {...getOverrideProps(overrides, "techSheetPalate")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings: values,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            values = result?.techSheetPairings ?? values;
          }
          setTechSheetPairings(values);
          setCurrentTechSheetPairingsValue("");
        }}
        currentFieldValue={currentTechSheetPairingsValue}
        label={"Abbinamenti"}
        items={techSheetPairings}
        hasError={errors?.techSheetPairings?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks(
            "techSheetPairings",
            currentTechSheetPairingsValue
          )
        }
        errorMessage={errors?.techSheetPairings?.errorMessage}
        setFieldValue={setCurrentTechSheetPairingsValue}
        inputFieldRef={techSheetPairingsRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Abbinamenti"
          isRequired={false}
          isReadOnly={false}
          value={currentTechSheetPairingsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.techSheetPairings?.hasError) {
              runValidationTasks("techSheetPairings", value);
            }
            setCurrentTechSheetPairingsValue(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "techSheetPairings",
              currentTechSheetPairingsValue
            )
          }
          errorMessage={errors.techSheetPairings?.errorMessage}
          hasError={errors.techSheetPairings?.hasError}
          ref={techSheetPairingsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "techSheetPairings")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Temperatura di servizio minima (°C)"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={techSheetServingTemperatureMin}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin: value,
              techSheetServingTemperatureMax,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetServingTemperatureMin ?? value;
          }
          if (errors.techSheetServingTemperatureMin?.hasError) {
            runValidationTasks("techSheetServingTemperatureMin", value);
          }
          setTechSheetServingTemperatureMin(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "techSheetServingTemperatureMin",
            techSheetServingTemperatureMin
          )
        }
        errorMessage={errors.techSheetServingTemperatureMin?.errorMessage}
        hasError={errors.techSheetServingTemperatureMin?.hasError}
        {...getOverrideProps(overrides, "techSheetServingTemperatureMin")}
      ></TextField>
      <TextField
        label="Temperatura di servizio massima (°C)"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={techSheetServingTemperatureMax}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax: value,
              techSheetCertifications,
            };
            const result = onChange(modelFields);
            value = result?.techSheetServingTemperatureMax ?? value;
          }
          if (errors.techSheetServingTemperatureMax?.hasError) {
            runValidationTasks("techSheetServingTemperatureMax", value);
          }
          setTechSheetServingTemperatureMax(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "techSheetServingTemperatureMax",
            techSheetServingTemperatureMax
          )
        }
        errorMessage={errors.techSheetServingTemperatureMax?.errorMessage}
        hasError={errors.techSheetServingTemperatureMax?.hasError}
        {...getOverrideProps(overrides, "techSheetServingTemperatureMax")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              brand_name,
              product_name,
              registered_region,
              style,
              price_ex_vat,
              bottles_per_year,
              year_of_production,
              container_size_cl,
              abv_percentage,
              tags,
              product_image,
              techSheetDescription,
              techSheetProductType,
              techSheetSoil,
              techSheetProductionArea,
              techSheetFormat,
              techSheetAgingCapacity,
              techSheetYearOfPlanting,
              techSheetVinification,
              techSheetAppearance,
              techSheetNose,
              techSheetPalate,
              techSheetPairings,
              techSheetServingTemperatureMin,
              techSheetServingTemperatureMax,
              techSheetCertifications: values,
            };
            const result = onChange(modelFields);
            values = result?.techSheetCertifications ?? values;
          }
          setTechSheetCertifications(values);
          setCurrentTechSheetCertificationsValue("");
        }}
        currentFieldValue={currentTechSheetCertificationsValue}
        label={"Certificazioni"}
        items={techSheetCertifications}
        hasError={errors?.techSheetCertifications?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks(
            "techSheetCertifications",
            currentTechSheetCertificationsValue
          )
        }
        errorMessage={errors?.techSheetCertifications?.errorMessage}
        setFieldValue={setCurrentTechSheetCertificationsValue}
        inputFieldRef={techSheetCertificationsRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Certificazioni"
          isRequired={false}
          isReadOnly={false}
          value={currentTechSheetCertificationsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.techSheetCertifications?.hasError) {
              runValidationTasks("techSheetCertifications", value);
            }
            setCurrentTechSheetCertificationsValue(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "techSheetCertifications",
              currentTechSheetCertificationsValue
            )
          }
          errorMessage={errors.techSheetCertifications?.errorMessage}
          hasError={errors.techSheetCertifications?.hasError}
          ref={techSheetCertificationsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "techSheetCertifications")}
        ></TextField>
      </ArrayField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Cancella"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap={tokens.space.large.value}
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Invia"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
